export const TEXT_ALIGNMENT_BUTTON_DATA_HOOK = 'textDropDownButton_Alignment';
export const TEXT_ALIGNMENT_LEFT_BUTTON_DATA_HOOK = 'textAlignmentButton_left';
export const TEXT_ALIGNMENT_CENTER_BUTTON_DATA_HOOK = 'textAlignmentButton_center';
export const TEXT_ALIGNMENT_RIGHT_BUTTON_DATA_HOOK = 'textAlignmentButton_right';
export const TEXT_ALIGNMENT_JUSTIFY_BUTTON_DATA_HOOK = 'textAlignmentButton_justify';
